import PRM from "@/core/PermissionConstants";

export default {
    path: "/app/interpretacion/validar",
    name: "INTERPRETATION-VALIDATE",
    component: () => import("@/app/views/InterpretationView.vue"),
    meta: {
        service: () => import("@/app/services/InterpretationValidateService"),
        table: () => import("@/app/components/interpretation/validate/InterpretationValidateTable.vue"),
        form: () => import("@/app/components/interpretation/validate/InterpretationValidateForm.vue"),
        addenumViewer: () => import("@/app/components/interpretation/validate/interpretationAddenumViewer.vue"),
        serviceDialog: () => import("@/app/services/TemplateDialogService"),
        tableDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogTable.vue"),
        formDialog: () => import("@/app/components/dialog/templateDialog/TemplateDialogForm.vue"),
      header: {
        icono: "mdi-clipboard-text-outline",
        texto: "Historial de interpretación",
        textNew: "",
        textEdit: "Editar interpretación",
      },
      headerDialog: {
        icono: "mdi-wrench",
        texto: "Plantilla",
        textNew: "Nueva plantilla",
        textEdit: "Editar plantilla",
      },
      prm: PRM.MODULE_INTERPRETATION_VALIDATE,
      requireAuth: true,
      filterDate: true,
      hideButtonAdd: true,
      addButtonText: "GUARDAR INTERPRETACIÓN",
      saveButtonText: "Validar",
      filterModality: true,
      cancelationModal: true,
      generatePDFModal: true,
      history: true,
      addenumViewerFlag: true,
      hideButtonAddDialog: false,
      addButtonTextDialog: "AGREGAR PLANTILLA",      
    },
  };
  